module.exports = __webpack_public_path__ + "static/media/GiorgiGvantseladze.33cf9f4c.jpg";